import { useSearch } from "common/router/hooks";

import { useActiveCartQuery } from "client/carts/hooks";
import { urls } from "client/routes";

import CheckoutPage from "./CheckoutPage";
import CheckoutAuthenticationProvider from "../providers/CheckoutAuthenticationProvider";
import { CheckoutPaths } from "../routes";
import { CheckoutStep } from "../types";

const CheckoutRootContent = () => {
  const { data: cart, isLoading, error } = useActiveCartQuery();
  const search = useSearch<CheckoutPaths["detail"]>();

  if (isLoading) {
    return <CheckoutPage.Loading />;
  }

  if (!cart || error) {
    return (
      <CheckoutPage.RedirectInvalid
        dest={urls.checkout.error({ search: { status: error?.status } })}
      />
    );
  }

  if (cart.is_closed) {
    return <CheckoutPage.RedirectInvalid dest={urls.checkout.confirmation()} />;
  }

  return (
    <CheckoutPage.RedirectInvalid
      dest={urls.checkout.detail({
        params: {
          step: CheckoutStep.Items,
        },
        search,
      })}
    />
  );
};

// Redirects to the correct starting step of checkout based on the Cart
const CheckoutRoot = () => {
  return (
    <CheckoutAuthenticationProvider>
      <CheckoutRootContent />
    </CheckoutAuthenticationProvider>
  );
};

export default CheckoutRoot;
